module.exports = __webpack_public_path__ + "img/map.dc51b4f7.png";